import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Partner} from '../../../../../../models/partner/partner';

import {PartnerCappingRuleService} from '../../../../../../services/partner/partner-capping-rule.service';
import {PartnerCappingRule} from '../../../../../../models/partner/partner-capping-rule';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {CappingRuleFormComponent} from '../capping-rule-form/capping-rule-form.component';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {ConfirmDirective} from '../../../../../../directives/confirm/confirm.directive';

@Component({
  selector: 'app-capping-rule-list',
  imports: [
    ConfirmDirective
],
  templateUrl: './capping-rule-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './capping-rule-list.component.scss'
})
export class CappingRuleListComponent implements OnInit {

  @Input() partner: Partner | null = null;

  rules: PartnerCappingRule[] = [];
  loaded: boolean = false;

  constructor(
    private cappingRuleService: PartnerCappingRuleService,
    private snackbar: SnackbarService,
    private dialog: DialogService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    if (this.partner) {
      this.cappingRuleService.findAll({partnerId: this.partner.id}).subscribe((rules: PartnerCappingRule[]) => {
        this.rules = rules;
        this.loaded = true;
      });
    }
  }

  openForm(cappingRule: PartnerCappingRule | null = null): void {
    this.dialog.openDialog(CappingRuleFormComponent, {
      data: {
        partner: this.partner,
        cappingRule,
      },
      class: 'modal-lg',
    }).subscribe((result) => {
      if (result) {
        this.fetchAll();
      }
    });
  }

  deleteRule(cappingRule: PartnerCappingRule): void {
    if (cappingRule.id) {
      this.cappingRuleService.delete(cappingRule.id).subscribe(() => {
        this.fetchAll();

        this.snackbar.success('The capping rule has been deleted.');
      });
    }
  }

}
